export default {

// API New Path
// API_URL: 'http://10.0.14.43:8082', 
// API_URL: 'http://localhost:8082/api', 
// API_URL: 'http://3.7.241.90/api', 
// API_URL: 'http://13.235.141.170/api'
// API_URL:'https://fcplm.brainbees.com/api'
 API_URL:window.location.origin + '/api'
}



